import * as React from "react";
import { connect } from "react-redux";

import Unit from "../../screens/Settings/Unit";
import {
  fetchUnitlist,
  AddUnit,
  DeleteUnit,
  EditUnit,
  unitSlectedPage
} from "./action";
class UnitContainer extends React.Component<Props, State> {
  render() {
    return (
      <Unit
        fetchUnitlist={this.props.fetchUnitlist}
        UnitList={this.props.UnitList}
        UnitCount={this.props.UnitCount}
        AddUnit={this.props.AddUnit}
        DeleteUnit={this.props.DeleteUnit}
        EditUnit={this.props.EditUnit}
        unitSlectedPage={this.props.unitSlectedPage}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    fetchUnitlist: () => {
      dispatch(fetchUnitlist());
    },
    AddUnit: value => {
      // console.log(value);
      dispatch(AddUnit(value));
    },
    DeleteUnit: value => {
      dispatch(DeleteUnit(value));
    },
    EditUnit: value => {
      dispatch(EditUnit(value));
    },
    unitSlectedPage: value => {
      dispatch(unitSlectedPage(value));
    }
  };
}
const mapStateToProps = state => {
  return {
    UnitList: state.UnitReducer.UnitList,
    UnitCount: state.UnitReducer.UnitCount
  };
};

export default connect(
  mapStateToProps,
  bindAction
)(UnitContainer);
